import { createFileRoute } from '@tanstack/react-router'
import { AiSection } from '../../../../features/settings/ai-section'
import { requireSection } from '../../../../features/settings/guards'

/** Settings › AI assistant (ai.manage, the `ai` module). */
export const Route = createFileRoute('/_app/settings/ai/')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'ai'),
  component: AiSection,
})
